<template>
    <div>
        <ds-list-item
            v-for="item in listItems"
            :key="item.id"
            #title
            clickable
            target="_blank"
            @click="handleClick(item)"
        >
            <ds-avatar :name="item.id.toString()" /> {{ item.label }}
        </ds-list-item>
    </div>
</template>


<script>
import amplitude from '../util/analytics/amplitude';


const CLASSIC_LINKS = [
    {
        id: 1,
        link: 'https://help.infusionsoft.com/help/list-hygiene',
        label: 'Clean your email lists',
    },
    {
        id: 2,
        link: 'https://keap.com/business-success-blog/marketing/email-marketing/building-email-reputation',
        label: 'Learn about your sending reputation',
    },
    {
        id: 3,
        link: 'https://help.infusionsoft.com/help/how-to-avoid-content-filters',
        label: 'Review your email content',
    },
    {
        id: 4,
        link: '/app/miscSetting/itemWrapper?systemId=nav.marketing&settingModuleName=Marketing&settingTabName=email.addressstatus.limits.title',
        label: 'Set List Automation',
    },
];

const UPDATED_CLASSIC_LINKS = [
    {
        id: 1,
        link: 'https://help.infusionsoft.com/help/email-bounces-explained',
        label: 'Email Bounces Explained',
    },
    {
        id: 2,
        link: 'https://help.infusionsoft.com/help/email-reputation-essentials',
        label: 'Learn about your sending reputation',
    },
    {
        id: 3,
        link: 'https://help.infusionsoft.com/help/list-hygiene',
        label: 'Review List Hygiene',
    },
    {
        id: 4,
        link: 'https://help.infusionsoft.com/help/how-to-avoid-content-filters',
        label: 'Check your Content and Subject Line',
    },
    {
        id: 5,
        link: 'https://help.infusionsoft.com/help/automated-list-management',
        label: 'Set Automated List Management',
    },
];

const KEAP_LINKS = [
    {
        id: 1,
        link: 'https://help.keap.com/help/list-hygiene',
        label: 'Clean your email lists',
    },
    {
        id: 2,
        link: 'https://keap.com/business-success-blog/marketing/email-marketing/building-email-reputation',
        label: 'Learn about your sending reputation',
    },
    {
        id: 3,
        link: 'https://help.keap.com/help/how-to-avoid-content-filters',
        label: 'Review your email content',
    },
];

const UPDATED_KEAP_LINKS = [
    {
        id: 1,
        link: 'https://help.keap.com/help/email-bounces-explained',
        label: 'Email Bounces Explained',
    },
    {
        id: 2,
        link: 'https://help.infusionsoft.com/help/email-reputation-essentials',
        label: 'Learn about your sending reputation',
    },
    {
        id: 3,
        link: 'https://help.keap.com/help/list-hygiene',
        label: 'Review List Hygiene',
    },
    {
        id: 4,
        link: 'https://help.infusionsoft.com/help/how-to-avoid-content-filters',
        label: 'Check your Content and Subject Line',
    },
];


export default {
    props: {
        isUpdateHelpArticleLinksEnabled: {
            type: Boolean,
            default: false,
        },
        isUnengagedEmailStatusProcessingEnabled: Boolean,
        appEdition: String,
    },
    computed: {
        icon() {
            return 'circle';
        },
        showSetListManagementCallToAction() {
            return Boolean(this.isUnengagedEmailStatusProcessingEnabled);
        },
        listItems() {
            const isClassic = this.appEdition === 'Keap Max Classic Edition';
            const isUpdated = this.isUpdateHelpArticleLinksEnabled;

            if (isClassic) {
                return isUpdated ? UPDATED_CLASSIC_LINKS : CLASSIC_LINKS;
            }

            return isUpdated ? UPDATED_KEAP_LINKS : KEAP_LINKS;
        },
    },
    methods: {
        handleClick(object) {
            window.open(object.link, '_blank');

            this.emitAmplitudeEvent(object.label);
        },
        emitAmplitudeEvent(event) {
            amplitude.infusionsoft.track('Email Analytics - CTA / Help', {
                'Event Source': 'Email Analytics Bounce Page',
                Destination: event,
            });
        },

    },
};

</script>

<style lang="scss" scoped>

#leadingSlot {
    padding: 0;
}

.list-item-description {
    font-size: $font-size-md;
    padding-right: $spacing-200;
}

.row {
    display: flex;
}

.column-left {
    flex: 50%;
    float: left;
}

.column-right {
    flex: 50%;
    text-align: right;
}

</style>
